<div class="consulta" *ngIf="consulta">

    <div class="info">
        <div class="descricao">
            <span class="tipo">{{consulta.descricao}}</span>
            <span class="status">{{consulta.statusConsultaString}}</span>
        </div>

        <div class="options" *ngIf="!isHome">
            <button type="button" class="btn btn-outline-secondary" (click)="toggleExpand()">
                <i class="hgi hgi-stroke" [ngClass]="expanded ? 'hgi-arrow-down-01' : 'hgi-arrow-up-01'"></i>
            </button>
        </div>
    </div>

    <div class="data-hora">
        <p>
            <i class="hgi hgi-stroke hgi-clock-01"></i>
            <span>{{ consulta.dataConsulta | date: 'dd/MM/yyyy' }}</span>
        </p>

        <p>
            <i class="hgi hgi-stroke hgi-calendar-03"></i>
            <span>{{ horaInicio }} - {{ horaFim }}</span>
        </p>
    </div>

    <hr>
    <perfil [expanded]="expanded" [paciente]="consulta.paciente" [profissional]="consulta.profissionalSaude" />

    <div *ngIf="!isHome">
        <ng-container *ngIf="expanded">
            <hr>
            <expandable titulo="Observações do Paciente" icone="hgi-sticky-note-01">
                <textarea name="observacaoPaciente" class="textarea-observacao" [(ngModel)]="novaObservacaoPaciente"
                    (blur)="atualizarObservacoes(false)"></textarea>
                <button type="button" class="btn btn-lg btn-block btn-outline-secondary"
                    (blur)="atualizarObservacoes(false)">
                    <span>Salvar</span>
                </button>
            </expandable>

            <exames-prescricoes [consulta]="consulta" (onRefresh)="getConsulta()"></exames-prescricoes>

            <expandable *ngIf="isProfissional" titulo="Observações do Profissional de Saúde" icone="hgi-task-01">
                <textarea name="observacaoProfissional" class="textarea-observacao"
                    [(ngModel)]="novaObservacaoProfissional" (blur)="atualizarObservacoes(isProfissional)">
                </textarea>
                <button type="button" class="btn btn-lg btn-block btn-outline-secondary"
                    (blur)="atualizarObservacoes(isProfissional)">
                    <span>Salvar</span>
                </button>
            </expandable>
        </ng-container>
    </div>
</div>